export const STATUS = {
  in_attesa: { label: "In attesa", cls: "bg-amber-100 text-amber-700" },
  accettato: { label: "Accettato", cls: "bg-blue-100 text-blue-700" },
  in_preparazione: { label: "In preparazione", cls: "bg-indigo-100 text-indigo-700" },
  pronto: { label: "Pronto per il ritiro", cls: "bg-successbg text-successtext" },
  in_consegna: { label: "In consegna", cls: "bg-orange/15 text-orange-600" },
  consegnato: { label: "Consegnato", cls: "bg-successbg text-successtext" },
  rifiutato: { label: "Rifiutato", cls: "bg-errorbg text-errortext" },
  annullato: { label: "Annullato", cls: "bg-errorbg text-errortext" },
};

export const STATUS_LABEL = (s) => (STATUS[s] || { label: s, cls: "bg-slate-100 text-slate-600" });

export const eur = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;

export function StatusBadge({ status, testid }) {
  const s = STATUS_LABEL(status);
  return <span data-testid={testid} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${s.cls}`}>{s.label}</span>;
}
